// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAuth from '@websanova/vue-auth'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Bearer from './auth/bearer.js'
import VueAuthAxios from '@websanova/vue-auth/drivers/http/axios.1.x'
import VueRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x'
import i18n from './translate'
import vbclass from 'vue-body-class'
import FlagIcon from 'vue-flag-icon'
import VueTrumbowyg from 'vue-trumbowyg'
import VoerroTagsInput from '@voerro/vue-tagsinput'
import moment from 'vue-moment'
import VueLocalStorage from 'vue-localstorage'
import * as uiv from 'uiv'
import RequestStack from './plugins/requestStack/index'
import SalesMachine from './plugins/salesmachine/index'
import * as Sentry from '@sentry/browser'
import initHelpHero from 'helphero'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://42fd9642ebce404b84f2768494309822@sentry.io/1225768',
    integrations: [new Sentry.Integrations.Vue({ Vue })],
    environment: process.env.NODE_ENV
  })
}

Vue.prototype.$env = process.env.NODE_ENV

Vue.prototype.$hlp = initHelpHero('nZ0eTIvo9xH')

Vue.use(VueLocalStorage, {
  name: 'localStorage',
  bind: true
})

Vue.component('tags-input', VoerroTagsInput)
Vue.use(VueTrumbowyg)

Vue.use(FlagIcon)

Vue.config.productionTip = false

Vue.use(VueAxios, axios)

Vue.axios.defaults.baseURL = process.env.API_URL

Vue.use(vbclass, router)

Vue.router = router

Vue.use(uiv)

Vue.prototype.$apiUrl = process.env.API_URL
Vue.prototype.$proxies = process.env.PROXIES
Vue.prototype.$proxies2 = process.env.PROXIES2

Vue.use(VueAuth, {
  auth: Bearer,
  http: VueAuthAxios,
  router: VueRouter,
  fetchData: {
    url: '/auth/me'
  },
  refreshData: {
    method: 'POST',
    interval: 700
  },
  googleOauth2Data: {
    url: 'https://accounts.google.com/o/oauth2/v2/auth',
    params: {
      redirect_uri: function () {
        return this.options.getUrl() + '/sso'
      },
      client_id: process.env.GOOGLE_ID,
      scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/plus.me https://www.googleapis.com/auth/plus.login'
    }
  }
})

App.router = Vue.router

router.beforeEach((to, from, next) => {
  if (typeof this.$requestStack !== 'undefined') {
    this.$requestStack.flush()
  }
  next()
})

Vue.use(RequestStack)

Vue.use(moment)

Vue.prototype.$eventHub = new Vue() // Global event bus

Vue.filter('truncate', function (text, stop, clamp) {
  return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
})

Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0
  })
  return formatter.format(value)
})

Vue.prototype.$user = new Vue({
  methods: {
    isIdexlab: function () {
      let user = this.$auth.user()
      return user !== null ? user.profile.id === 1 : false
    },
    isOrange: function () {
      let user = this.$auth.user()
      return user !== null && typeof user.profile !== 'undefined' ? user.profile.id === 2 : false
    },
    isSme: function (plan) {
      let user = this.$auth.user()
      return user !== null ? user.profile.id === 3 : false
    },
    isSe: function (plan) {
      let user = this.$auth.user()
      return user !== null && typeof user.profile !== 'undefined' ? user.profile.id === 4 : false
    },
    isSafran: function (plan) {
      let user = this.$auth.user()
      return user !== null && typeof user.profile !== 'undefined' ? user.profile.id === 5 : false
    },
    isBicWorld: function (plan) {
      let user = this.$auth.user()
      return user !== null && typeof user.profile !== 'undefined' ? user.profile.id === 6 : false
    },
    isGAC: function (plan){
      let user = this.$auth.user()
      return user !== null && typeof user.profile !== 'undefined' ? user.profile.id === 7 : false
    },
    isBasic: function () {
      let user = this.$auth.user()
      return user !== null && typeof user.plan !== 'undefined' ? (user.plan.plan_id === 1 || user.plan.plan_id === 6) : false
    },
    isFreeTrial: function () {
      let user = this.$auth.user()
      return user.email === 'trial@idexlab.com' || user.email === 'demo@idexlab.com'
    },
    isSilver: function () {
      let user = this.$auth.user()
      return user !== null ? user.plan.plan_id === 2 : false
    },
    isDiamond: function () {
      let user = this.$auth.user()
      return user !== null ? user.plan.plan_id === 3 : false
    },
    isBusiness: function () {
      let user = this.$auth.user()
      return user !== null ? user.plan.plan_id === 4 : false
    },
    isCorporate: function () {
      let user = this.$auth.user()
      return user !== null ? user.plan.plan_id === 5 : false
    },
    isExpected: function () {
      let user = this.$auth.user()
      return user !== null && user.profile.individual_plans_exception_list ? user.profile.individual_plans_exception_list.indexOf(this.getDomainName(user.email)) !== -1 : false
    },
    getDomainName: function (userEmail) {
      return userEmail.trim().split('@')[1]
    },
    hasExpertProfile: function () {
      let user = this.$auth.user()
      return !(typeof user.expert === 'undefined' || !user.expert.length)
    },
    hasDefaultPassword () {
      let user = this.$auth.user()
      return user.changePasswordRequired
    },
    hasEmailVerified () {
      let user = this.$auth.user()
      return user.email_verified
    },
    hasPhoneVerified () {
      let user = this.$auth.user()
      return user.phone_verified
    },
    trialIsUsed () {
      return this.$auth.user().trialIsUsed
    },
    isExpert () {
      let user = this.$auth.user()
      return user !== null ? user.plan.plan_id === 6 : false
    },
    canBlockchain () {
      return this.$auth.user().plan.account_blockchain
    },
    hasAdvanceNews () {
      return this.$auth.check('super_admin') || this.$auth.user().plan.account_advance_news
    },
    level () {
      let user = this.$auth.user()
      let score = (user.oi_score) ? user.oi_score.oi_score : null
      if (!score || score < 1) return {current: 'Beginner', next: 'Novice'}
      else if (score < 11) return {current: 'Novice', next: 'Intermediate'}
      else if (score < 21) return {current: 'Intermediate', next: 'Advanced'}
      else if (score < 41) return {current: 'Advanced', next: 'Specialist'}
      else if (score < 61) return {current: 'Specialist', next: 'Master'}
      else if (score < 81) return {current: 'Master', next: 'Grand master'}
      else if (score < 100) return {current: 'Grand master', next: 'Guru'}
      else return {current: 'Guru', next: 'Guru'}
    },
    oiScore () {
      let user = this.$auth.user()
      return (user.oi_score) ? user.oi_score.oi_score : null
    }

  }
})

Vue.use(SalesMachine)

new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  i18n,
  router: router
})



// WEBPACK FOOTER //
// ./src/main.js